(function () {
  'use strict';

  /**
   * 车型适配结果埋点。
   *
   * 查询发起时暂存车型与入口信息，结果正常返回后再上报。
   * 集合页发生整页跳转时，由目标集合页读取暂存信息并完成上报。
   */
  const tracking = window.jiniuTracking;

  if (!tracking) {
    console.error('[SensorsData] Tracking core is unavailable');
    return;
  }

  const EVENT_NAME = 'fitment_result';
  const PENDING_KEY = '_jiniu_pending_fitment';
  const PENDING_TTL = 10 * 60 * 1000;
  const FITMENT_PARAMETER = 'filter.v.m.custom.ymme_data';

  function normalizeText(value) {
    return value === null || value === undefined
      ? ''
      : String(value).trim();
  }

  function getPathname(value) {
    if (!normalizeText(value)) {
      return '';
    }

    try {
      return new URL(value, window.location.origin).pathname;
    } catch (error) {
      return '';
    }
  }

  function removePendingQuery() {
    try {
      window.sessionStorage.removeItem(PENDING_KEY);
    } catch (error) {
      // sessionStorage may be unavailable in privacy-restricted browsers.
    }
  }

  function getPendingQuery() {
    let storedValue = '';

    try {
      storedValue = window.sessionStorage.getItem(PENDING_KEY) || '';
    } catch (error) {
      return null;
    }

    if (!storedValue) {
      return null;
    }

    try {
      const pendingQuery = JSON.parse(storedValue);

      if (
        !pendingQuery ||
        typeof pendingQuery !== 'object' ||
        !pendingQuery.year ||
        !pendingQuery.make ||
        !pendingQuery.model ||
        !pendingQuery.engine ||
        !pendingQuery.createdAt ||
        Date.now() - pendingQuery.createdAt > PENDING_TTL
      ) {
        removePendingQuery();
        return null;
      }

      return pendingQuery;
    } catch (error) {
      removePendingQuery();
      return null;
    }
  }

  function startQuery(query) {
    const pendingQuery = {
      year: normalizeText(query?.year),
      make: normalizeText(query?.make),
      model: normalizeText(query?.model),
      engine: normalizeText(query?.engine),
      buttonText: normalizeText(query?.buttonText),
      componentPosition: normalizeText(query?.componentPosition),
      source: normalizeText(query?.source),
      targetPath: getPathname(query?.targetUrl),
      createdAt: Date.now()
    };

    if (
      !pendingQuery.year ||
      !pendingQuery.make ||
      !pendingQuery.model ||
      !pendingQuery.engine
    ) {
      return false;
    }

    try {
      window.sessionStorage.setItem(
        PENDING_KEY,
        JSON.stringify(pendingQuery)
      );
      return true;
    } catch (error) {
      console.error('[SensorsData] Unable to store pending fitment', error);
      return false;
    }
  }

  function completeQuery(resultCount) {
    const pendingQuery = getPendingQuery();
    const numericResultCount = Number(resultCount);

    if (!pendingQuery || !Number.isFinite(numericResultCount)) {
      return false;
    }

    removePendingQuery();
    tracking.publish(EVENT_NAME, {
      year: pendingQuery.year,
      make: pendingQuery.make,
      model: pendingQuery.model,
      engine: pendingQuery.engine,
      button_text: pendingQuery.buttonText,
      result_count: Math.max(0, Math.trunc(numericResultCount)),
      component_position: pendingQuery.componentPosition
    });
    return true;
  }

  window.jiniuFitmentTracking = Object.freeze({
    start: startQuery,
    complete: completeQuery,
    cancel: removePendingQuery
  });

  function completeCollectionNavigation() {
    const context = window.jiniuTrackingContext || {};
    const pendingQuery = getPendingQuery();

    if (context.pageType !== 'collection' || pendingQuery?.source !== 'collection') {
      return;
    }

    const completedFitment = new URLSearchParams(window.location.search).get(
      FITMENT_PARAMETER
    );
    const expectedFitment = [
      pendingQuery.year,
      pendingQuery.make,
      pendingQuery.model,
      pendingQuery.engine
    ].join('|');
    const resultCount = Number(context.collectionResultCount);
    const isExpectedDestination =
      completedFitment === expectedFitment ||
      (
        pendingQuery.targetPath &&
        window.location.pathname === pendingQuery.targetPath
      );

    if (
      isExpectedDestination &&
      Number.isFinite(resultCount)
    ) {
      completeQuery(resultCount);
    }
  }

  completeCollectionNavigation();
})();
